import PropTypes from 'prop-types';

const StopSharingIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill={fill} fillRule="evenodd">
        <path d="m18.768 9.672 5.225 5.227 5.225-5.227c2.044-2.045 5.174 1.032 3.1 3.106l-5.222 5.224 5.222 5.228c2.04 2.04-1.063 5.143-3.1 3.103l-5.225-5.225-5.223 5.225c-2.04 2.04-5.14-1.063-3.105-3.103l5.227-5.228-5.227-5.224c-2.035-2.04 1.065-5.146 3.105-3.106h-.002z" />
        <path d="M42 0a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h36zm-1.5 4.5h-33c-1.656 0-3 1.344-3 3v21c0 1.656 1.344 3 3 3h33c1.656 0 3-1.344 3-3v-21c0-1.656-1.344-3-3-3z" />
        <rect y="39" width="48" height="4.5" rx=".938" />
      </g>
    </svg>
  </div>
);

StopSharingIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

StopSharingIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default StopSharingIcon;
